// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InvioceInfo[data-v-08c1fc1f] {\n  background-color: white;\n  padding: 30px;\n}\n.InvioceInfo .addInvoice[data-v-08c1fc1f] {\n    margin: 30px 30px 0 0;\n}\n.box-card[data-v-08c1fc1f] {\n  width: 50%;\n  margin-top: 20px;\n  font-size: 14px;\n}\n.box-card p[data-v-08c1fc1f] {\n    line-height: 30px;\n}\n.page[data-v-08c1fc1f] {\n  margin-top: 50px;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
